/// <reference types="vite/client" />

export default class Util {
  static authHeaders(): Record<string, any> {
    const token = this.getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  static getCookie(name: string): string | null {
    const regex = new RegExp("(^|;\\s*)(" + name + ")=([^;]*)");
    const match = regex.exec(document.cookie);
    return match ? decodeURIComponent(match[3]) : null;
  }

  static getToken(): string {
    return this.getCookie("token") ?? "";
  }

  static saveToken(token: string) {
    this.setCookie("token", token, 1, import.meta.env.VITE_DOMAIN);
  }

  static removeToken() {
    this.removeCookie("token", import.meta.env.VITE_DOMAIN);
  }

  static removeCookie(name: string, domain?: string): void {
    let cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;

    if (domain) {
      cookie += `; domain=${domain}`;
    }

    document.cookie = cookie;
  }

  static setCookie(
    name: string,
    value: string,
    days: number,
    domain?: string,
  ): void {
    let cookie = `${name}=${encodeURIComponent(value)}; path=/`;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      cookie += `; expires=${date.toUTCString()}`;
    }

    if (domain) {
      cookie += `; domain=${domain}`;
    }

    document.cookie = cookie;
  }
}
